<script setup>
import useGrid from "@/composables/useGrid";
import {computed, onMounted, ref} from "vue";
import CommonGrid from "../../../../../frontend/src/components/CommonGrid.vue";
import emailLogsService from "@/services/notification-email-logs.service";
import notificationEmailLogsService from "@/services/notification-email-logs.service";
import LogModal from "@/views/tools/notificationEmailLogs/LogModal.vue";

const {items, gridParams, gridMethods} = useGrid(emailLogsService.getIndexList);
const objectTypes = ref([]);
const logModal = ref(null);

const columns = [
    {
        label: 'Company Name',
        name: 'company_name',
        filter: 'text',
    },
    {
        label: 'Account Type',
        name: 'company_type',
        filter: 'single-select',
        options: [
            {
                id: 'Enterprise',
                name: 'Enterprise'
            },
            {
                id: 'Ecosystem',
                name: 'Ecosystem'
            },
            {
                id: 'Startup',
                name: 'Startup'
            }
        ]
    },
    {
        label: 'User Name',
        name: 'user_name',
        filter: 'text',
    },
    {
        label: 'Email',
        name: 'email',
        filter: 'text',
    },
    {
        label: 'Object Type',
        name: 'object_type',
        filter: 'single-select',
    },
    {
        label: 'Sent',
        name: 'created_at',
    },
    {
        name: 'actions',
        label: 'Actions',
        component: 'Actions',
    },
];

const actualColumns = computed(() => {
    return columns.map(column => {
        if (column.name === 'object_type') {
            return {
                ...column,
                options: objectTypes.value.map(item => ({id: item, name: item}))
            }
        }
        return column;
    });
});

onMounted(() => {
    gridMethods.setColumns(columns);
    gridMethods.resetList();
    getObjectTypes();
});

function gridAction(params) {
    if (params.action === 'view') {
        logModal.value.open(params.rowId);
    }
}

async function getObjectTypes() {
    const {data} = await notificationEmailLogsService.getObjectTypes();
    objectTypes.value = data;
}

</script>

<template>
    <div>
        <div class="main-table-wrapper">
            <div class="main-table overflow-auto">
                <CommonGrid
                    :columns="actualColumns"
                    :items="items"
                    :gridParams="gridParams"
                    :gridMethods="gridMethods"
                    :gridAction="gridAction"
                />
            </div>
        </div>

        <LogModal ref="logModal"/>
    </div>
</template>

<style scoped>

</style>
